import React, { useState, useEffect } from 'react';
import '../App.css';
import { Doughnut, Bar, Line } from 'react-chartjs-2';
import Axios from 'axios'
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Map from '../Map/Map';
import CountUp from 'react-countup';




//https://covid19.mathdro.id/api

function Covid() {

  // return(
  //   <div style={{textAlign:'center', padding:150}} >
  //     <title>Site Maintenance</title>


  //       <article style={{display:'block', textAlign:'left', width:650, margin:'0 auto'}} >
  //           <h1 style={{fontSize:50}} >We&rsquo;ll be back soon!</h1>
  //           <div>
  //               <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. We&rsquo;ll be back online shortly!</p>
  //           </div>
  //       </article>
  //   </div>
  // )


    useEffect(() => {
        let one = "https://vigrant-vitale.herokuapp.com/api/covid"
        let two = "https://covid19.mathdro.id/api"
        // let three = 'https://ngcovid19.com.ng/api/user/v1/timeline'
        const requestOne = Axios.get(one);
        const requestTwo = Axios.get(two);
        // const requestThree = Axios.get(three);
        Axios.all([requestOne, requestTwo]).then(Axios.spread((...res) => {
          const responseOne = res[0].data
          const responseTwo = res[1].data
          // const responseThree = res[2].data
          // const orderedArray = responseThree.data.reverse()
          // const modifiedData = orderedArray.map((daily) => ({
          //     confirmed: daily.totalcases,
          //     deaths: daily.deaths,
          //     discharged: daily.discharged,
          //     date: daily.date
          // }))
          // setDailyData(modifiedData)
          setState({covid:responseOne, global:responseTwo})
    
        })).catch(errors => {
          // react on errors.
        })
    
      }, [])
  const [dailyData, setDailyData] = useState([])
  const colors = []
  const [state, setState] = useState({
    covid: '',
    global:'',
    total: ''
  })

  
  const [searchstate, setSearchstate] = useState('')
  const handleSearchInput = (e) => {
    setSearchstate(e.target.value)
  }

  console.log('[STATE]', state)
  if(!state.covid){
    return (
      <div style={{height:'100vh', width:'100%'}} >
        <div className="loader">Loading...</div>
      </div>
    )
  }


 

 

  const statedata = []
  const affectedStates = state.covid.state
    


   const filterStates = affectedStates.filter(state => {
     return state.state.toLowerCase().includes(searchstate.toLowerCase())
  })

  filterStates.forEach((item, index) => {
    const randomColor = Math.floor(Math.random()*16777215).toString(16)
    statedata.push(
              <tr key={index} >
                <td>{item.state}</td>
                <td>{item.totalCases_labConfirmed}</td>
                {/* <td>+{item.changetotal} ({Math.round((item.changetotal / item.totalcases) * 100) ? Math.round((item.changetotal / item.totalcases) * 100) + '%' : '0%'}) </td> */}
                <td style={{color:'#D1BB68'}} >{item.totalCases_onAdmission}</td>
                <td style={{color:'#6BBF95'}} >{item.discharged}</td>
                {/* <td>+{item.changedischarged} ({Math.round((item.changedischarged / item.discharged) * 100) ? Math.round((item.changedischarged / item.discharged) * 100) + '%' : '0%'})</td> */}
                <td style={{color:'#fb6383'}} >{item.deaths}</td>
                {/* <td style={{color:'#fb6383'}} >+{item.changedeaths} ({Math.round((item.changedeaths / item.deaths) * 100 ) ? Math.round((item.changedeaths / item.deaths) * 100)+'%' : '0%' })</td> */}
              </tr>
    )
    colors.push('#'+randomColor)
 })



  const chartData = {
    labels: [
      state.covid.state[0].state, 
      state.covid.state[1].state, 
      state.covid.state[2].state, 
      state.covid.state[3].state, 
      state.covid.state[4].state,
      state.covid.state[5].state,
      state.covid.state[6].state,
      state.covid.state[7].state,
      state.covid.state[8].state,
      state.covid.state[9].state,
      state.covid.state[10].state,
      state.covid.state[11].state,
      state.covid.state[12].state,
      state.covid.state[13].state,
      state.covid.state[14].state,
      state.covid.state[15].state,
      state.covid.state[16].state,
      state.covid.state[17].state,
      state.covid.state[18].state,
      state.covid.state[19].state,
      state.covid.state[20].state,
      state.covid.state[21].state,
      state.covid.state[22].state,
      state.covid.state[23].state,
      state.covid.state[24].state,
      state.covid.state[25].state,
      state.covid.state[26].state,
      state.covid.state[27].state,
      state.covid.state[28].state,
      state.covid.state[29].state,
      state.covid.state[30].state,
      state.covid.state[31].state,
      state.covid.state[32].state,
      state.covid.state[33].state,
      state.covid.state[34].state,
     ],
    datasets:[
      {
        label: 'Confirmed cases',
        data:[
          state.covid.state[0].totalCases_labConfirmed, 
          state.covid.state[1].totalCases_labConfirmed, 
          state.covid.state[2].totalCases_labConfirmed, 
          state.covid.state[3].totalCases_labConfirmed, 
          state.covid.state[4].totalCases_labConfirmed,
          state.covid.state[5].totalCases_labConfirmed,
          state.covid.state[6].totalCases_labConfirmed,
          state.covid.state[7].totalCases_labConfirmed,
          state.covid.state[8].totalCases_labConfirmed,
          state.covid.state[9].totalCases_labConfirmed,
          state.covid.state[10].totalCases_labConfirmed,
          state.covid.state[11].totalCases_labConfirmed,
          state.covid.state[12].totalCases_labConfirmed,
          state.covid.state[13].totalCases_labConfirmed,
          state.covid.state[14].totalCases_labConfirmed,
          state.covid.state[15].totalCases_labConfirmed,
          state.covid.state[16].totalCases_labConfirmed,
          state.covid.state[17].totalCases_labConfirmed,
          state.covid.state[18].totalCases_labConfirmed,
          state.covid.state[19].totalCases_labConfirmed,
          state.covid.state[20].totalCases_labConfirmed,
          state.covid.state[21].totalCases_labConfirmed,
          state.covid.state[22].totalCases_labConfirmed,
          state.covid.state[23].totalCases_labConfirmed,
          state.covid.state[24].totalCases_labConfirmed,
          state.covid.state[25].totalCases_labConfirmed,
          state.covid.state[26].totalCases_labConfirmed,
          state.covid.state[27].totalCases_labConfirmed,
          state.covid.state[28].totalCases_labConfirmed,
          state.covid.state[29].totalCases_labConfirmed,
          state.covid.state[30].totalCases_labConfirmed,
          state.covid.state[31].totalCases_labConfirmed,
          state.covid.state[32].totalCases_labConfirmed,
          state.covid.state[33].totalCases_labConfirmed,
          state.covid.state[34].totalCases_labConfirmed,
        ],
        backgroundColor:colors
      }
    ]
  }

  const summary = state.covid

  const totalPie = {
    labels:['ACTIVE', 'RECOVERED', 'DEAD'],
    datasets:[
        {
            label: 'Totals Chart',
            data:[
                +state.covid.activeCases,
                +state.covid.dischargedCases,
                +state.covid.death
            ],
            backgroundColor:['#C1AE65', '#6BBF95', '#C85C75']
        }
    ]
  }

  const outcomePie = {
    labels:['ACTIVE', 'RECOVERED'],
    datasets:[
        {
            label: 'Totals Chart',
            data:[
                summary.dischargedCases,
                summary.death
            ],
            backgroundColor:['#C1AE65', '#6BBF95']
        }
    ]
  }

  const recoveryrate = (summary.dischargedCases / summary.confirmedCases) * 100
  const deathrate = (+summary.death / +summary.confirmedCases) * 100

  console.log('CONFIRMED' ,state.covid.confirmedCases)

 
  return (
    <div className="App">
                <div>
          <header className="App-header"> 
      <div className='Header' >
        <p className='Header__title' >Nigeria COVID-19 Stats</p>
        <p className='Header__subtitle' >Visit the <span><a target='blank' href='https://covid19.ncdc.gov.ng/' >NCDC</a> </span> Site for more info.</p>
        {/* <div class="marquee">
          <p  style={{color:'#C05B73', fontSize:16, fontWeight:'bold'}}>Disclaimer!. Information compiled from the NCDC Site and values are sometimes reviewed and changed. Please Notify Seyi for any errors or feedback via twitter, email or whatsapp +26878514450. Thanks. </p>
        </div> */}
        <div class="  rightTI li">★ Disclaimer!. Information compiled from the NCDC Site and values are sometimes reviewed and changed. Please Notify Bemsnet for any errors or feedback via call or whatsapp +2348012345678. Thanks.  ★</div>

        <div className='Global-report' >
          <p className='Global-report-text'>Global Report:</p>
          <p className='Global-report-text'>Confirmed: <span style={{color:'#1596A7'}} > <CountUp start={0} separator=',' end={state.global.confirmed.value} /> </span>  </p>
          <p className='Global-report-text'>Deaths: <span style={{color:'#C85C75'}} ><CountUp start={0} separator=',' end={state.global.deaths.value} /></span></p>
          <p className='Global-report-text'>Recovered: <span style={{color:'#6BBF95'}} ><CountUp start={0} separator=',' end={state.global.recovered.value} /></span></p>
        </div>
      </div>
      </header>
      <div className='mapview' >
        <Map data={affectedStates} />
      </div>
      {/* <div className='chart' >
              <Line
              height={300}
                data={{
                  labels:dailyData.map(({date}) => date),
                  datasets:[{
                      data: dailyData.map(({confirmed}) => confirmed),
                      label:'Total',
                      borderColor:'#E2C86B',
                      fill:true
                  }
                  , {
                      data: dailyData.map(({discharged}) => discharged),
                      label:'Recovered',
                      borderColor:'#159E18',
                      // backgroundColor: 'rgba(0,0,0, .2)' ,
                      fill:true
                  }, {
                      data: dailyData.map(({deaths}) => deaths),
                      label:'Deaths',
                      borderColor:'red',
                      backgroundColor: '#DD5F7B' ,
                      fill:true
                  }],
                  
                }}
                options={{
                  title:{
                      display:true,
                      text:"Confirmed cases and recovery daily chart",
                      fontSize:18,
                      fontColor:'#fff'
                  },
                  legend:{
                      display:true,
                      labels:{
                        fontColor:'#fff'
                      },
                  },
              }}
              /> */}
      {/* </div> */}
     
      <div className='container'>
        <div className='container__sidebar'>
          <div className='container__sidebar-figures' >
            <p className='container__sidebar-p' >Last updated: {moment(state.global.lastUpdate).format('LLLL')} </p>
            <div className='container__sidebar-cases'>Coronavirus Cases:</div>
            <div className='container__sidebar-cases-num'> {state.covid.confirmedCases}</div>
            <div className='container__sidebar-cases'>Deaths:</div>
            <div className='container__sidebar-death-num'><CountUp start={0} separator=',' end={state.covid.death || 0 } /></div>
            <div className='container__sidebar-cases'>Recovered:</div>
            <div className='container__sidebar-rec-num'>{state.covid.dischargedCases} </div>
            <div className='container__sidebar-cases'>Tests:</div>
            <div className='container__sidebar-test-num'>{summary.samplesTested}</div>
          </div>
          <div className='container__sidebar-figures' >
              {/* <Chart /> */}

              


              <Bar
                data={chartData}
                options={{
                    legend:{
                        labels:{
                            fontColor:'#fff'
                        }
                    }
                }}
              />

            <div className='container__sidebar-totals-chart'>Totals Chart</div>
            <Doughnut
                data={totalPie}
                options={{
                    legend:{
                        labels:{
                            fontColor:'#fff'
                        }
                    }
                }}
              />
              <div style={{color:'#fff', marginTop:10}} >Active:<span style={{color:'#C1AE65'}} >{summary.activecases} </span> Recovered:<span style={{color:'#6BBF95'}}>{summary.discharged} </span> Deaths:<span style={{color:'#ff0000'}}>{summary.deaths} </span> </div>

            <div className='container__sidebar-totals-chart'>Outcomes Chart</div>
            <Doughnut
                data={outcomePie}
                options={{
                    legend:{
                        labels:{
                            fontColor:'#fff'
                        }
                    }
                }}
              />
              <div style={{color:'#fff', marginTop:10}}> Recovered:<span style={{color:'#6BBF95'}}><CountUp start={0} separator=',' end={summary.discharged} /> </span> Deaths:<span style={{color:'#ff0000'}}>{summary.deaths} </span> </div>

          </div>
        </div>
        <div className='container__content' >
            <div className="timenav">
              {/* <DatePicker
              className='Datepicker'
              selected={startDate}
              onChange={handleDateChange}
              /> */}
            </div>
            <div className='statistics' >
              <h1>Statistics by State  </h1>
            </div>
            <div className='progress_bar' >
              <div className='recoveryrate' >
                <p className='statistics-p'>Total Recovery rate</p>
                <p>{Math.round(recoveryrate)}% </p>
                <ProgressBar className='recoveryratecolor'  variant='success' min={0} max={100} now={recoveryrate}   /></div>
              <div className='fatrate' >
                <p className='statistics-p'>Total Fatality rate</p>
                <p>{Math.round(deathrate)}% </p>
                <ProgressBar variant='danger' min={0} max={100} now={deathrate} />
              </div>
              <p className='statistics-p'>Total cases: <span style={{color:'#1596A7'}} ><CountUp start={0} separator=',' end={summary.totalcases} /></span></p>
              <p className='statistics-p'>Tests: <span style={{color:'#1596A7'}} > <CountUp start={0} separator=',' end={summary.test} /> </span></p>
            </div>
            <div className='statistics__search' >
              <input value={searchstate} placeholder='Search state' onChange={handleSearchInput} />
            </div>
            <div className='statistics__table' >
            <table className='statistics__state-table table table-hover table-dark striped bordered hover collapsed sticky-header ' striped='true' bordered='true' hover='true' variant="dark" responsive='true'>
                <thead  >
                  <tr>
                    <th style={{color:'#B4B4B4'}} className='tablehead'>State</th>
                    <th style={{color:'#B4B4B4'}} className='tablehead'>Total Confirmed cases</th>
                    {/* <th style={{color:'#B4B4B4'}} className='tablehead'>New Cases</th> */}
                    <th style={{color:'#E2C86B'}} className='tablehead'>Active</th>
                    <th style={{color:'#159E18'}} className='tablehead'>Discharged</th>
                    {/* <th style={{color:'#159E18'}}  className='tablehead'>Closed</th> */}
                    <th style={{color:'#DD5F7B'}} className='tablehead'>Deaths</th>
                    {/* <th style={{color:'#DD5F7B'}} className='tablehead'>New Deaths</th> */}
                  </tr>
 
                </thead>
              <tbody>
                {statedata}
              </tbody>
            </table>
            </div>
        </div>
      </div>
        </div>
    </div>
  );
}

export default Covid;
